import { Environment } from './environment-type';

/**
 * Build servido en el subdominio dev (ej. `admin-dev.fition.lat`).
 *
 * - API: `https://dev.fition.lat/api` (CORS manejado en el backend).
 * - Firebase: proyecto `fition-dev`.
 *
 * Build: `npm run build:dev`.
 */
export const environment = {
  production: false,
  apiBaseUrl: 'https://dev.fition.lat/api',
  firebase: {
    apiKey: 'AIzaSyCCZeZa7aPOt5l087GVYX8ez6CNwvmPUjk',
    authDomain: 'fition-dev.firebaseapp.com',
    projectId: 'fition-dev',
    storageBucket: 'fition-dev.firebasestorage.app',
    messagingSenderId: '523398405564',
  },
  mvpDemoOffline: false,
} satisfies Environment;
